import { IAsset, IMyBid } from '@northladder/services';

import { IFetchBidDetailsData } from '../types';

import { getBidRankStatus, normalizeBidTag } from './formatBidSearchResults';

export function formatBidDetailsResult(
  assetRaw: IFetchBidDetailsData,
  isRankOneBidDisplayEnabled: boolean
): IAsset {
  // NOTE: : Exiting early not to break types for some reason if the asset is null
  if (!assetRaw?.assetDetails) return {} as IAsset;

  let myBid: IMyBid | null = null;
  const { assetDetails, creditLimitDetails } = assetRaw;

  const {
    _id,
    attributes,
    brandId,
    brandLogo = null,
    gapToFirstRank = null,
    brandName = '',
    categoryName = '',
    imageUrl,
    name,
    stepperValue = 0,
    tag,
    topBid,
    hotDealFlag: isHotDeal = false,
  } = assetDetails;

  const topBidDate = topBid?.updatedDate || 0;
  const myBidDate = assetDetails?.myBid?.updatedDate || 0;

  const lastUpdatedOn = topBidDate > myBidDate ? topBidDate : myBidDate;

  if (assetDetails?.myBid) {
    const {
      autoTopupEnabled: isAutoTopupEnabled,
      availableQuantity = 0,
      _id: bidId = '',
      isBidActive,
      isSpotSummit,
      maxQuantity,
      rank,
      spotPrice,
      updatedDate,
    } = assetDetails.myBid;

    /**
     * If the auto topup is enabled, set the available quantity to 0.
     * Because if isAutoTopupEnabled true backend is giving default quantity as 5.
     * So in the UI we cannot select 5 as available quantity.
     */
    const formattedAvailableQuantity = isAutoTopupEnabled
      ? 0
      : availableQuantity;

    myBid = {
      availableQuantity: formattedAvailableQuantity,
      bidId,
      isAutoTopupEnabled,
      isBidActive,
      isSpotSummit,
      itemCondition: '', // Why this value. See also bids search. is it used?
      maxQuantity,
      rank,
      rankNumber: rank,
      spotPrice,
      updatedDate,
      topSpotPrice: topBid?.spotPrice || 0,
    };
  }

  let assetNameStr = `${brandName || ''} ${name || ''} `;
  assetNameStr += attributes.map((attr) => `${attr.value}`).join(', ');

  // TODO: Add arabic name later as iraq team needs english name for now.
  // let assetNameAr = `${brandName || ''} ${name || ''} `;
  // assetNameAr += attributes.map((attr) => `${attr.value_ar}`).join(', ');
  let assetNameES = `${brandName || ''} ${name || ''} `;
  assetNameES += attributes.map((attr) => `${attr.value_es}`).join(', ');

  const normalizedTag = normalizeBidTag(tag);
  const myBidDetails = assetDetails?.myBid;

  const rankStatus = getBidRankStatus(
    myBidDetails
      ? {
          availableQuantity: myBidDetails.availableQuantity,
          isBidActive: myBidDetails.isBidActive,
          isSpotSummit: myBidDetails.isSpotSummit,
          rank: myBidDetails.rank,
        }
      : null,
    isRankOneBidDisplayEnabled
  );

  const myBidPrice = myBid?.isBidActive ? myBid?.spotPrice || 0 : 0;

  const cleanAsset: IAsset = {
    assetId: _id,
    assetImage: imageUrl,
    assetName: {
      en: assetNameStr,
      // ar: assetNameAr || assetNameStr,
      ar: assetNameStr,
      es: assetNameES || assetNameStr,
    },
    assetNameLabel: assetNameStr,
    brandId,
    brandLogo,
    brandName,
    categoryName,
    gapToFirstRank,
    creditLimitDetails,
    lastUpdatedOn,
    isHotDeal,
    myBid,
    myBidPrice,
    myBidQuantity: myBid?.availableQuantity || 0,
    rankStatus,
    stepperValue: stepperValue || 0,
    rank: normalizedTag,
    topBidAmount: topBid?.spotPrice || 0,
    name: name || null,
    icon: 'other', // Compute dynamically based on category/brand/name
    page: 0, // TODO: Add this to the API to use later in cache updates.
  };

  return cleanAsset;
}
